import React from 'react';
import styled from 'styled-components';

import Wrapper from './wrapper';
import { media, TransitionMixin } from '../helpers';

import Hills from '../../images/hills.inline.svg';

// TODO: Connect form

const ContactFormContainer = styled.div`
    padding: 100px 0 150px;
    background-color: #f74d33;
    position: relative;

    .form-container {
        max-width: 90vw;
        margin: 0 auto;
        position: relative;
        z-index: 10;

        ${media.small`max-width: 400px;`}

        .title-container {
            text-align: center;
            h3 {
                color: #fff;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                font-size: 2rem;
            }

            p {
                color: #fff;
            }
        }

        form {
            margin-bottom: 0px;
            position: relative;
            z-index: 10;
            .input-row {
                margin-bottom: 20px;
                &:last-child {
                    margin-bottom: 0;
                }
                .input-container {
                    display: flex;
                    flex-wrap: wrap;
                    > * {
                        flex: 1 1 100%;
                    }
                    label {
                        font-weight: bold;
                        text-align: left;
                        color: #fff;
                        margin-bottom: 5px;
                    }

                    input {
                        background-color: #f2f0eb;
                        border-radius: 5px;
                        border: none;
                        padding: 7px 0px 7px 15px;
                        color: #702716;
                    }
                    textarea {
                        background-color: #f2f0eb;
                        border-radius: 5px;
                        padding: 15px;
                        max-height: 150px;
                        border: none;
                        color: #702716;
                    }
                }

                &.split {
                    ${media.small`display: flex;`}
                    .input-container {
                        flex: 1;
                        margin-bottom: 20px;
                        ${media.small`margin-bottom: 0px;`}

                        &:first-child {
                            ${media.small`margin-right: 15px;`}
                        }
                    }
                }
            }
            button {
                flex: 1.5;
                font-weight: bold;
                background-color: #f74c34;
                border: 1px solid #f74c34;
                color: #fff;
                border-radius: 5px;
                border-color: #fff;
                font-weight: 800;
                max-width: 150px;
                width: 100%;
                padding: 7px 0;
                font-family: neue-kabel, sans-serif;
                ${media.small`flex: 1; border-color: #f74c34;`}
                ${TransitionMixin('.25s')}

                &:hover {
                    background-color: #fff;
                    color: #f74c34;
                }
            }
        }
    }

    .svg-container {
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 100%;

        svg {
            width: 100%;
            height: auto;

            g {
                mask: none;
            }
        }
    }
`;

const ContactForm = () => {
    return (
        <ContactFormContainer>
            <Wrapper className="form-container">
                <div className="title-container">
                    <h3>We're Happy to Answer your Questions.</h3>
                    <p>
                        Contact our sales team and we’ll be back in touch as
                        soon as we can.
                    </p>
                </div>

                <form>
                    <div className="input-row split">
                        <div className="input-container">
                            <label htmlFor="first_name">First Name</label>
                            <input type="text" />
                        </div>
                        <div className="input-container">
                            <label htmlFor="last_name">Last Name</label>
                            <input type="text" />
                        </div>
                    </div>
                    <div className="input-row">
                        <div className="input-container">
                            <label htmlFor="email">Email</label>
                            <input type="email" />
                        </div>
                    </div>
                    <div className="input-row">
                        <div className="input-container">
                            <label htmlFor="comments">Comments</label>
                            <textarea
                                name=""
                                id=""
                                cols="30"
                                rows="10"
                            ></textarea>
                        </div>
                    </div>
                    <div className="btn-container">
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </Wrapper>
            <div className="svg-container">
                <Hills />
            </div>
        </ContactFormContainer>
    );
};

export default ContactForm;
